import { render, staticRenderFns } from "./User-Management.vue?vue&type=template&id=2b10d396&scoped=true&"
import script from "./User-Management.vue?vue&type=script&lang=js&"
export * from "./User-Management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b10d396",
  null
  
)

export default component.exports